/**
 * Publicações relacionadas, a compact stat in the candidature header: the campaign's related-post
 * share over the window `api`'s `related_post_share` reads, linking into the review of its complement -- the
 * window's posts the share did not count. A bare percentage with a dead link is worse than no
 * card, so the link renders whatever the share is.
 *
 * `null` (nothing collected in the window yet) renders no figure and no caption, never a dash --
 * a measured `0%` and "we have not measured yet" are different facts and the card never
 * conflates them. The frame's trend chip ("+4 p.p.") is not drawn: nothing serves a prior-window
 * share to compare against.
 */
import { ChevronRight } from 'lucide-react';
import type { ReactNode } from 'react';
import { Link } from '@tanstack/react-router';

import { getLocale } from '../../../i18n';
import { integer, percent } from '../../../i18n/format';
import { OUT_OF_GROUP_PATH } from './outOfGroup.routes';
import { rm } from './recordMessages';

export function RelevanceCard(props: {
  campaignId: string;
  share: number | null;
  related: number | null;
  total: number | null;
}): ReactNode {
  const locale = getLocale();
  return (
    <div className="flex flex-col gap-0.5 sm:items-end sm:text-right">
      <p className="text-caption text-muted-foreground">{rm('relatedPosts.title')}</p>
      {props.share !== null && (
        <span data-numeric className="text-title-md">
          {percent(props.share, locale)}
        </span>
      )}
      {props.share !== null && props.related !== null && props.total !== null && (
        <p className="text-caption text-muted-foreground">
          {rm('relatedPosts.window', {
            related: integer(props.related, locale),
            total: integer(props.total, locale),
          })}
        </p>
      )}
      <Link
        to={OUT_OF_GROUP_PATH}
        params={{ campaignId: props.campaignId }}
        className="flex w-fit items-start gap-1 text-caption text-muted-foreground hover:text-foreground underline-offset-4 hover:underline sm:flex-row-reverse"
      >
        <ChevronRight aria-hidden className="size-3.5" />
        {rm('relatedPosts.review')}
      </Link>
    </div>
  );
}
